export default "/img/iapilogo.102037ceb6cdffafa76d49dbbc022047.png";